var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isSendListSelected
    ? _c("conversation-list", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isBusy,
            expression: "isBusy",
          },
        ],
        key: _vm.conversationListKey,
        ref: "list",
        attrs: {
          "index-url": _vm.indexUrl,
          margin: 8,
          note: _vm.note,
          "read-only-notes": _vm.readOnlyNotes,
          "store-note-url": _vm.getStoreNoteUrl,
          "send-list-id": _vm.getSendListId,
          "can-set-read-only-note": _vm.canSetReadOnlyNote,
        },
        on: {
          delete: _vm.onDelete,
          edit: _vm.onEdit,
          "open-chat": _vm.onOpenChat,
          restore: _vm.onRestore,
          move: _vm.onMove,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }